import React from 'react';
import '../style/Kyagu.scss';
// component
import Header from '../components/public/Header';
import PhotoGallery from '../components/thirdParty/PhotoGallery';
// React Bootstrap
import { Container, Row, Col, Image, Tab, Nav } from 'react-bootstrap';
// React redux
import { connect } from 'react-redux';

function Kyagu1({ lang }) {
  const k1 =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fk01.png?alt=media&token=23b1f333-022a-4773-abb7-f00bddcfa6e1';
  const hatImages = [
    {
      // no 2
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FbaromHat2.png?alt=media&token=4d6515fe-4aeb-4a2d-8508-4a8051231a07',
      width: 5,
      height: 3,
    },
    {
      // no 1
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FbaromHat1.png?alt=media&token=818ecb69-aa4b-45ed-b3e4-eead901cd12e',
      width: 5,
      height: 3,
    },
  ];
  const barompaBanner = 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FbarompaBanner.png?alt=media&token=7a57e7b5-8c12-4890-81f1-8fad7677b50a';
  const mountainBanner = 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmountainBanner.png?alt=media&token=5b928088-1928-444d-a8fc-fa5011889614';
  const monastryBanner = ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FmonastryBanner2.jpg?alt=media&token=28454762-d610-4816-9462-746b05317157';
  const baromHat = 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2FbaromHatBanner.png?alt=media&token=ff6c9eee-bf29-4950-9d87-b652e9001092';
  const mountain1 = [
    {
      // no 5
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmountain5.jpg?alt=media&token=2ead38f1-8dea-4b93-be33-d22f42e62ada',
      width: 3,
      height: 5
    },
    {
      // no 6
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmountain6.jpg?alt=media&token=acd528b6-e905-470f-85f5-757d05eedf85',
      width: 5,
      height: 3
    },

  ]

  const makers = [
    {
      // no 1
      src: ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmakers1.jpg?alt=media&token=e4c17f82-711a-40d6-b226-1d8116fcc37e',
      width: 5,
      height: 3,
    },
    {
      // no 2
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmakers2.jpg?alt=media&token=1fef0e4a-4b2c-4f10-ab78-6da61fe66871',
      width: 3,
      height: 5
    }
  ]

  const monastry1 = [
    {
      // no 1
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmonastry1.jpg?alt=media&token=c061411e-aad1-452d-ad9c-e7554a25166d',
      width: 5,
      height: 3,
    },
    {
      // no 2
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fmonastry2.jpg?alt=media&token=68fd55e7-43c0-4eca-898a-330722a3b9ac',
      width: 5,
      height: 3,
    },
  ];
  return (
    <>
      <Header />
      <Container className='kyagu'>
        <div className='kyaguBody pt-4 pr-5 pl-5'>
          <Tab.Container id='left-tabs' defaultActiveKey='1'>
            {/* Header Bar content */}
            <Row className=''>
              <Col>
                <Tab.Content className='headerBanner'>
                  <Tab.Pane eventKey='1' className='tabPane'>
                    {/* Header Image */}
                    <Image src={k1} rounded fluid />
                    {/* Title */}
                    {lang === 'CH' ? (
                      <h3 className='text-left text-secondary chinese mb-3 '>
                        達瑪旺秋 1127-1199
                      </h3>
                    ) : lang === 'TIB' ? (
                      <h3 className='text-left text-secondary tibetan_Dutsa mb-3'>
                        བོད་ཡིག་
                      </h3>
                    ) : (
                          <h3 className='text-left text-secondary mb-3'>English</h3>
                        )}
                  </Tab.Pane>
                  <Tab.Pane eventKey='7' className='tabPane'>
                    <Image src={barompaBanner} rounded fluid />
                  </Tab.Pane>
                  <Tab.Pane eventKey='8' className='tabPane'>
                    <Image src={baromHat} rounded fluid />
                  </Tab.Pane>
                  <Tab.Pane eventKey='9' className='tabPane'>
                    <Image src={monastryBanner} rounded fluid />
                  </Tab.Pane>
                  <Tab.Pane eventKey='10' className='tabPane'>
                    <Image src={mountainBanner} rounded fluid />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
            {/* Left Key Buttons */}
            <Row>
              <Col sm={5} md={3}>
                <Nav variant='pills' className='flex-column '>
                  {/* Tap 1 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='1'>
                      {lang === 'CH' ? (
                        <h4>自傳</h4>
                      ) : lang === 'TIB' ? (
                        <h4>རྣམ་ཐར།</h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 2 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='2'>
                      {lang === 'CH' ? (
                        <h4>大手印</h4>
                      ) : lang === 'TIB' ? (
                        <h4>ཕྱག་ཆེན། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 3 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='3'>
                      {lang === 'CH' ? (
                        <h4>那若六法</h4>
                      ) : lang === 'TIB' ? (
                        <h4>ཆོས་དྲུག </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 4 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='4'>
                      {lang === 'CH' ? (
                        <h4>道歌</h4>
                      ) : lang === 'TIB' ? (
                        <h4>རྡོ་རྗེས་མགུར། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 5 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='5'>
                      {lang === 'CH' ? (
                        <h4>教言</h4>
                      ) : lang === 'TIB' ? (
                        <h4>ཞལ་གདམ། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 6 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='6'>
                      {lang === 'CH' ? (
                        <h4>儀軌</h4>
                      ) : lang === 'TIB' ? (
                        <h4>འདོན་ཆ།</h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 7 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='7' >
                      {lang === 'CH' ? (
                        <h4>法相</h4>
                      ) : lang === 'TIB' ? (
                        <h4>འདྲ་འབག </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 8 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='8'>
                      {lang === 'CH' ? (
                        <h4>法帽</h4>
                      ) : lang === 'TIB' ? (
                        <h4>དབུ་ཞྭ། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 9 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='9'>
                      {lang === 'CH' ? (
                        <h4>佛寺</h4>
                      ) : lang === 'TIB' ? (
                        <h4>དགོན་པ།</h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 10 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='10'>
                      {lang === 'CH' ? (
                        <h4>閉關地</h4>
                      ) : lang === 'TIB' ? (
                        <h4>སྒྲུབ་གནས། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 11 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='11'>
                      {lang === 'CH' ? (
                        <h4>加持物</h4>
                      ) : lang === 'TIB' ? (
                        <h4>བྱིན་རླབས། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>

                  {/* Tap 12 */}
                  <Nav.Item className='navItem'>
                    <Nav.Link eventKey='12'>
                      {lang === 'CH' ? (
                        <h4>紀念法會</h4>
                      ) : lang === 'TIB' ? (
                        <h4>འདས་མཆོད། </h4>
                      ) : (
                            <h4>english</h4>
                          )}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>

              {/* Content */}
              <Col sm={7} md={9}>
                <Tab.Content className='tabContent'>
                  <Tab.Pane eventKey='1' className='tabPane'>
                    {lang === 'CH' ? (
                      <>
                        <h4 className='text-secondary chinese'>
                          八融巴达玛旺秋尊者传
                            </h4>
                        <p className='chineseParagraph p-2'>
                          达玛旺秋尊者公元1127年生于西藏澎域雍瓦地方的占迦家族，父亲名丹顿巴，母亲名洛穷玛。夫妇二人共有三个孩子，长子本嘉生于火羊年（注：次年，1134，第二饶回火羊年）。从幼年开始，除了修持佛陀的神圣教法之外，达玛旺秋就对其他的事情都不感兴趣，唯一的目标就是找寻最好的老师并随之学习。
                          当达玛旺秋长到七岁那年，家中来了一位手中拿着医疗器具（夹板），全身装扮成空行母形象的妇女。达玛旺秋感到很好奇，于是就走上前去问这位妇女到：“上师，请问你是谁的弟子”？“我是达波尼贡（即岗波巴）的弟子”。达玛旺秋转念一想又问到：“不可能吧，喇嘛仁波且没有女弟子，你一定是在说谎”。那位妇女便对他讲到说：“上师岗波巴怎麽能知道我的善呢？”这句话使达玛旺秋感到很不高兴，岗波巴大师是当时西藏公认的大成就者之一，达玛旺秋虽然当时还很年幼，但是他自然地对岗波巴大师充满着一种与生俱来的信心，没想到这位装扮成空行母的女士，看起来奇怪的女士竟然对这位无以伦比的伟大上师如此的不尊敬，于是他很认真的说到：“仁波且知道好”。讲完后好呼唤其他的小孩子对着这位妇女做出许多滑稽动作，并向着妇女扔石头。但是妇女并没有生气，妇女对达玛旺秋说：“你有信仰上师之标志，我不会打你，你去吧。”这位装扮成空行母的妇女其实就是真正的空行母的化身，由于达玛旺秋宿世的善缘，空行母善巧的将达玛旺秋引导向了岗波巴大师。那一晚，达玛旺秋辗转难眠，心中多次出现了去岗波巴大师住的地方干布的想法，这天夜里他还梦见喇嘛仁波且，并且在梦中悲切的观想、祈祷岗波巴大师。第二天早上天明时，从东方升起一束白光，犹如太阳的辔索，射进达玛旺秋的心间。达玛旺秋怀疑是鬼还是别的什麽，为此心中很是不能平静，于去就去请问格西旺雍缘由。格西旺雍告诉他说：“这不是代表什么魔鬼，只要你至心祈请喇嘛岗波巴（达波拉杰），将会得到喇嘛的加持。”
                          当达玛旺秋八岁时，从堪布噶瓦和阿闍黎旺秋循努处领受了出家戒，成为一名僧侣，并取名为达玛旺秋，而且达玛旺秋还授权成为祖父创建的噶瓦宇那庄园的主人。之后，举行了阿闍黎旺秋循努的朵玛法会,授施食权。说：“大护法，你作为我的同路伙伴，特别要为我的小沙弥做身影，一心做朋友，身不乱，语不乱，意不乱。”言毕，将食子置于头顶，说：“你今晚睡在我跟前，分别梦境。”“梦见碰头睡，明日会对你的众生有利，护法也喜欢你。身影结伴，需要之时回想起。今日凌晨我有很大一个海螺，两位吹螺者向佛宝献螺，螺声越来越响亮，连多康地区也能听到，这样的海螺，作为小沙弥的必需品。这时，来了一位长首有痣的黑人，我对他说好好保存海螺，他非常高兴，手拿螺。那麽，小沙弥的亲威必须托给他，正在想时，说了声沃德祖佐。”又，陈列食子，犹如象小沙弥的身影一样结伴保护，认真吩咐。
                          达玛旺秋十一岁时，把格西恰域巴请到恰喀尔布贡寺，并请教恰域巴菩提道次第的教授，受习忿怒不动王咒、觉沃大悲观音及觉姆度母教授，以及其他多种法。在格西喇嘛珠布隆巴跟前学习慈氏五部大论，《集学论》、《入菩萨行论》等法相方面的教法。格西喇嘛也讲了三士道教授。
                          格西珠布隆巴去世后，达玛旺秋跟随轨范师格西噶瓦学习《律经本论》等，听到喇嘛仁波且冈波巴（达波拉杰）的名字，油然生起信心。后来渐渐地，他生起很大的出离心，厌恶轮回。心里想诸法仿佛遮糖，密教方便道为快捷方式。触接三愆失、新肌者要提防。但是，临死时，如果生起邪嗔定会堕入恶趣。修死无常是法的根本，恒常修行，而贪着轮回的话，根本上就没有颠倒解脱的指望，“决断（除）闻思之增益，”如果弟子好，不去对治，而是增加傲气，慈悲是产生他利的基础，如果相信无所缘的空性无别，少许悲愍不一定产生他利；上师是三宝的根本，法王众生怙主三藐三佛陀化身来世，与别的不一样（不等于别的）。通过修行证义，具上师传承，必须恪守三昧耶。如果不具备这些，外止（奢摩他）如同睡卧，包裹道头。上师无知识功德，弟子渴望知识功德者，犹如水毁后（水涸）渴望酥油，对普通上师产生不了敬仰心。心不生以前的功德，即使生起也不知道，怀疑之功德变成过患。倘若有过，不知变成功德，将内心感受认作魔鬼，希望所破，疑惑所迎，入魔。说获得成就，出现障碍，生起邪见，允许修行，将一切难事抛入水中。对阿闍黎和尊者朋友造罪说藐视的讽剌话，法不谛实，如果谛实，现在我努力呼唤，或承事，或长久修行，不应有那样疾病，即使反感变心，也能看见听见，这是未谒上师相之过，三藏法说上师重要，如果不依上师不能成佛；身体努力修行”。达玛旺秋想：“如果觅得闻听之法，功德是否生起，关键靠自己”。那一晚，达玛旺秋彻夜难眠。第二天，他骑上驮子，想睡觉去了山上面，在一岩洞中发现瑜伽师白色胎发，一位英俊青年蹲坐在洞中。达玛旺秋问：“你从何处来，住在哪里”。英俊青年答道：“我从干布来谒上师仁波且的，现在也不知去何处。”听到此言，于是达玛旺秋便对他产生了共同的敬信。又继续问道：“上师冈波巴贵体安康吗？有多少侍从，主要宣讲什麽法？请你详细为我讲讲好吗？”瑜伽士双手合十说：“上师仁波且名声很大，他是为了正等觉佛徒众之事来此世间的。上师贵体安康，侍从众多，讲授了义法，特别讲授一生一世成佛的大乘密诀。除了这些，一日行开光安神两次。每当此时，住在圆铜器中，有希奇殊胜的事业。每日身穿着法衣将干树立于竈孔，并祈祷如果佛教事业宏扬光大的话，愿此干树可以重新生长。因此，干树开始生长，上师修习禅定，以随眠智（入光明定）讲解调伏法。是故，能够生起先功德，众侍从也是住地菩萨，心思瞻部洲众有情。所以，来到如我您如愿之处。他讲事业传记无量。顿穷（小导师－小师傅），你敬信杰仁波且，是做灾厄之障碍；你为杰仁波且之命中注定之天种，我来帮你引荐。”达玛旺秋说：“阿闍黎，我自幼听到上师仁波且的名声，非常敬仰。以前想去闻习佛法，他说没有求过学，因此产生怀疑而未去。今日，与你相遇，并为我讲述（上师）传记，我非常高兴，无论如何也要拜谒上师。我也希望解脱轮回生死，如果不去上师跟前，不可能有任何好处。现在怎麽办，只有同你商量，献你一袋糌粑”。瑜伽士说：“总而言之，密教是方便快捷方式，而我们的上师仁波且是没有障碍的特殊道。由于说到信心，你敬心大，故生功德。生起刹那信仰者，是福泽之殊胜。”达玛旺秋说：“现在时机已到，不能求学，到了修行院，也未修行。没有穗荚。你已得成就，如果没有自己接受许诺的先功德，是我欺骗，宝法稀有，常有多害。”瑜伽士说：“宝法之义正确，一生就能觉悟成佛，心有介绍之教诫是大手印，精进修行之觉悟者修猛厉火，不修而强迫觉悟者是修往生法，有痴者通过睡眠与梦觉悟者是修光明，有信仰者修习上师传法，恪守三昧耶，这样无论如何也能觉悟成佛。因此，不必有疑心。大格西和住地没有赞普的需要，此生受苦，后世进地狱，停止八法之求学，抛弃傲慢之喻，舍弃名利地位，戒除（远弃）贪嗔之轮回，放弃嫉之能所作，断绝痴绳，布施我面粉。”这样，两人说了不少知心话，寄托东西，并答应以后寄书信，瑜伽士强调说，如果事做多会成为法的障碍。瑜伽士还说：“朋友，有位听我言者，如果愿意一起带走，并且鼓励为善，也是一位好朋友。殊胜善者，倘能谒见仁波且（达波拉杰），就会得不还地果。做名言之忧思和名利之争，虽然人寿千年。但是做与上师佛晤面之缘，瑜伽士，你是引导我的有恩上师。如果你留下来，我会非常高兴，我现在准备去干布。如果你乐意，我是奴仆之友伴。瑜伽士答道，我是瑜伽士，没有固定的去处，祈请上师，没有任何困难。由于你具大敬心，定能生起功德。到那时我也高兴。明天去”。
                          跟这位英俊的瑜伽士见面完以后，八融巴达玛旺秋立刻回到家里，准备去工布的行装。朋友喇嘛波噶哇桑结贡巴当时已是一位小沙弥，八融巴问他：“你去不去达波拜见喇嘛仁波且，喇嘛是一位与正等觉佛没有区别的佛。如果想学法，首先必须找一位上师指导，象喇嘛（达波拉杰）那样的人现在于瞻部洲难以找到，上师的功德无量”。桑结贡巴听后信心倍增，答应一起去。喇嘛八融巴说：“现在立即走，不要让他人知道”。
                          于是，达玛旺秋和桑结贡巴俩人就带着茶和黄金等贽见礼，来到喇嘛达波仁波且座前，为仁波切献上茶金，说道：“我们久闻尊师盛名，仰望而来学法的，请赐教？”达波拉杰说：“如果诚心学法，必须厌离三界轮回，象护眼一样恪守戒律，敬信上师，切实做因果业，这样才能产生功德”。
                          初十早晨，做会供之时，八融巴达玛旺秋心想：“达波拉杰是真正的正等觉佛金刚持”。达波拉杰对他说：“你具大敬心，没有太多可传授的，有利你众生的法，你自己里面坐”。八融巴顺从地坐进里面。
                          后来，到了达拉冈波，已近冬季之时。八融巴感到身体不适，突然间身体长出了许多水泡，疼痛难忍，考虑如何处理是好。他想除了去正等觉佛上师仁波且跟前之外，如果寻找别的办法，我自己就可以回答。我听说别的地方的病人来这里祈祷，病得到好转。舍弃名利地位财物，在阿闍黎噶瓦巴处立过誓，现在出现病碍，是我自己的过错。经过一番深刻思考，八融巴开始专心禅定，诚心祈祷然后睡去，睡梦中梦见有一个犹如佛殿头顶一样的孔洞，通过孔看见一个浩大黑海中，聚积着许多鱼和蝌蚪，我很胆怯地想往里走之时，想到如果再见一次仁波且该多好。祈请过仁波且，再次想走时，突然喇嘛仁波且面带威猛相出现在我的面前，紧紧抓住八融巴左手无名指，说：“恶种畜生遍各地，傍生分别趋入意，恶运之地起疑心，万物轮涅是自心。敬信感戴缘起要，悲愍铁勾为装饰，行走不变大乐地。”言毕，将我轻轻拉上，一起升空。梦醒后，身体颇感轻松。虽然水泡还有，却感到爽快，产生无分别的特殊感受。
                          巴融巴达玛旺秋身材魁梧，不仅力气很大，而且也相当的敏捷。一次，达玛旺秋跟随达波拉杰岗波巴前往盖昌，岗波巴骑着一头无角白犏牛前往盖昌，路上牛脚被拖住，达波拉杰岗波巴从牛背上掉了下来，落地前的一瞬间被喇嘛八融巴接住。达波拉杰高兴地说到：“你今天特别能干”。避免了一次生命危险。又有一次，达波拉杰骑着一匹白马驹前去拉隆，突然马群中发出嘈声，他的马受惊狂奔起来，他从马上掉下，尚未落地前又被八融巴接住，达波拉杰极为高兴。
                          还有一次，应达波绒卡之请，八融巴陪同达波拉杰去参加开光仪式，参加法会的当地人特别多，也有不少僧人。当时发生了争抢宝瓶水和神馐鲜花、彩色细砂的现象。达波拉杰未能阻止，他自己也被人压在下面，经卷和佛像失落。喇嘛八融巴跑过去背起达波拉杰岗波巴从人群中逃出。因此，岗波巴达波拉杰说：“这次开光法会非常混乱，今天如果没有你，那些争抢者就会杀死我”。达波拉杰岗波巴问：“那些争抢的朋友们得到彩色细砂，你得到什麽？”喇嘛八融巴说:“我得到了一尊佛像”。达波拉杰看着佛像说：“你说的对，是尊佛像，如果不是你，无疑佛像就不在了”。大家都非常高兴。喇嘛八融巴更加坚定信仰，刹那住加持，无畏无凄，通达灾厄为友，心有无二，无二法身，无认识分别，弃舍所能修，无贪者，智无垢，作意清净，无生灭住，原本俱生，悲无所缘，他利天成（任运），寻思本位解脱，一切为尽，初智非造非灭，离一切惧贪，不作疑，难诠释，无符号所表示，生起纯正分别。他问达波拉杰出现如此分别的原因。达波拉杰说：“是那些（分别）”？达玛旺秋据实告知后，岗波巴并作了详细介绍，按照米拉日巴和空行母所授记，作道歌解释。
                          在一次会供轮法会上，达波拉杰说：“作为一名大修行者，必须从所感受中产生道歌。你的咽喉和圆满佛米拉日巴的妙音相同，是真正的分别（通达）。”八融巴说：“米拉日巴曲杰仁波且之道歌如同圆满佛人形之歌。”合掌低头，流着眼泪。上师达波拉杰加持八融巴，说：“加持你，对我有利。”上师解释：“以前我向阿闍黎嘉日贡迦哇求授灌顶，他说：“昨天，我向你灌顶，障碍我自己，你清净。”你也出现同样的情况，你为众生作答，是有利的。达波拉杰接着说：“在七百聚会弟中，唯有上座宇囊哇达玛旺秋和噶尔贡噶尔哇很有领悟”。
                          又有一日，喇嘛八融巴做法事感戴，干巴益希雍仲来叫他迅速到达波拉杰跟前。八融巴飞速奔跑，途中有一个极为可怕的深洞，以前他从这里走过，顺着原来的路他在洞顶绕行了很长时间,突然脚下一滑掉进岩穴，想必死无疑；念起达波拉杰（喇嘛仁波且）住在头顶，诵经归依。他用尽全身力气，在洞中间边找踩脚的地方，一边大声呼叫，牧人听到后，告诉了其他人，他们将一根长绳吊进洞穴，达玛旺秋抓住绳子向上攀，终于爬出岩洞，身体安然无恙。八融巴把事情经过告诉了达波拉杰。达波拉杰说：“死兆难以回退，他人不能遮退。由于你感戴我，使我非常伤惦，回退死兆。”八融巴回禀：“我掉进洞穴时，一直感念仁波且。”达波拉杰说：“那时我在你的跟前，愿长寿”。又说：“从今以后，要从根本上断除对世间事的贪着。”
                          从顿隆去恰贡之时，达波拉杰骑着白马，由于路况较差，马蹄踏空，快要从马上掉下落地时再一次被八融巴接住。”达波拉杰说：“马失蹄我很惧怕，你绝对能干。”之后，达玛旺秋亲自设座,铺以柔软的坐垫，请达波拉杰上座，并迎到很远地方。仁波且说：“此座如同印度轿子，非常大，是为您做的。”
                          总之，达波山谷地势宽阔，道路崎岖，仁波且亲临这里。喇嘛八融巴身背仁波且去上去下，恭敬承事，他人难以做到，这使喇嘛仁波且达波拉杰很高兴。他说：“八融巴体验独特，通达圆满，时常等引、后得不断，住大光明。”
                          一日里，喇嘛仁波且对达玛旺秋说：“我已将全部教授和你所希望的法传授与你，现在你去北方八融清净小庙修行，它位于冈底斯山脉，是尊者洛札玛尔巴师徒等成就师的修行地。”并送一两黄金给达玛旺秋，并说道：“我未向他人布施黄金，我们父子结伴时间很长，你舍身承事，从未违背我言，先用这些黄金维持生活修行，以后，会有人向你提供生活所需”。喇嘛八融巴想：众人上师仁波且犹如佛陀再世，住寺，心续清净，加持（我），我已承侍多年，闻习教诫。在众弟子中上师给予我特殊关心，除了喇嘛仁波且，世间再没有对我有大恩者。在梦中曲杰仁波且思考他利，去化身曼荼罗无量光佛刹土（极乐世界）。（达波拉杰）他化身没有烦恼，为了引导执常弟子，讲授圣者们所说法义，无老、病、死而往生。为了徒众，化身亦能善逝，如今他年事已高，身体重量增加，留下与以前不同的多种遗言。我不顾生命，多次消除上师寿元障害，上师没有说过一次不高兴的话，是他叫我到他跟前，又叫我去其他山间小庙修行，真有意思。如果是那样的话，我走了以后，仁波且往生怎麽办。因此我要长期依止仁波且，上师临终时没有我，人们会责骂。鉴于此，我无论如何也要留下承侍，无怨无悔，即便是其他人希望承侍，（上师）没有答应的话，我决不离开上师，尤其是上师健在时，我无论如何也不离去，请求允准。（以上为八融巴的想法）。
                          于是八融巴达玛旺秋流着眼泪请求上师恩护加持。达波拉杰说：“即使贪着亦细微，贪恋诸凡所系傅，根本解脱去空行，梦见山中修等味。”又说：“我已决定把黄金给你，你又一次献给我。由此因缘，有人会向你献黄金”。
                          一次，达波拉杰对达玛旺秋说：“你把我的法衣袋拿来，我把所有的经书给你”。八融巴说：“我不求经书，我不想做阿闍黎，只求上师仁波且恩护”。达波拉杰说：“你没有做他人阿闍黎的想法，也不想要经书，是要我自己写的书。”言毕，将自己撰写的书授与达玛旺秋，并说：“我已将全部教授传给你，不需要的书我不给。”“没有欲望的有情者，无所缘的大悲愍者，虔诚祈祷求授教化调伏一切的良法”。达波拉杰教导说：“施予你应得的财物碟碗二个、靠垫一个和三信，不要说不要，你去指甲（兽爪）上耕田的地方寻找衣食，去饿鬼地方乞讨面粉，能否觅得你修行的生活条件，你自己知道”，“要做没有疑望的敷具，不贪着散心的财物，做利他事自会有一切，到那时我会随念你。”
                          达玛旺秋说：“我不做也不愿以财物承侍，我乐意做修行承侍。”达波拉杰教导说：“我没有得到财物，你去山间小庙坚持禅定修炼，以后威仪等味，利益无依无怙的众生，最终使北方八融成为殊胜修行地。你应该去那清净小庙修行。现在我不答应你的请求，你想做什麽都行，我们父子一起的时间只有三十七天。”喇嘛八融巴起身，向达波拉杰岗波巴献曼荼罗，施礼并请求道：“喇嘛仁波且患心气病，无论如何请常住世。”达波拉杰说：“现在我在这里的事已圆满，他处尚有众生事需要去做，一定要走。”喇嘛八融巴极度伤心，向佛语传承的诸位上师祈祷，一定要留在干布承侍喇嘛仁波且。因此，他体悟本心分别义无别，轮涅一切法是本心（自心），心自然通达大手印法，没有非修之境，不需要不存在的其他方法，不必旁修非自性的空性智；无二义没有放舍，专心而做，不用努力，没有来去，魔、相、障碍等一切本位解脱，即使出现共同功德和暖相，都保密不请问上师，承事感戴喇嘛仁波且，一切功德都是因上师的加持而圆满。
                          一日，仁波且说：“若习纯正法，因信心和感戴而起意（等起）；若专心修道，佛果易证得。众弟子听着：效法善知识，八法弃于后，舍杂乱之心，戒律作庄严；信心生深处，决断心根本，迷乱从内坏，心有是一体，分别法身明。寻常智如光明无分离，一切法入道，恶缘为友。只有这时才能生起特殊信仰，趋入成就，息灭障害，利他，获得成就的距离近，聚集空行，上师欢喜是一切功德之根本。到那时，小庙禅院清净，没有胆怯与害怕，尽力吟唱金刚道歌，空行众欢喜，亦唱分别义歌。为了我的忌日供，你要在清净的小庙专心修行，献一束鲜花和一碗水感戴祈祷就行了。”
                          之后，八融巴达玛旺秋留侍达波拉杰，第三十二天，上师仁波且往生，灵塔造成前，法体安放在一位施主提供的房中。尸骨塔建成后用马载轿请到金殿供养，马在当地出售，由顿巴次程扎饲养。料理完后事，八融巴按照上师仁波且授记来到八融。这个地方属于恒河源头冈底斯雪山山脉，巴曹部落之地，大山石山纵横交错，也是去大宗札玛尔桑耶、唐钦秀姆四茹的山脉通道。绛钦清净小庙，大海秀姆背后（可能纳木错湖），大译师玛尔巴，建造讲院之处（地），瑜伽行者僧曲成就地，大咒力者发挥作用之地，杂钦天门雪山，是瞻部洲的山王。特别是八融山高峻威严，高扬的灵鹫胜幢仿佛天柱，形似优美。山头南云密布，山腰轻烟薄雾犹如玉带缠绕，使人悦意。在此夜叉大部落的宫殿所在地自然山前，堂皇之地，欢悦之境，杂钦天门山下有天成八融修行地无量宫殿，正等觉佛的亲传弟子（八融巴）象大仙一样专心修行。当时，他离开干布时未让其他任何人知道，只有香增窘乃送行。
                          有一天，八融巴在山间修行，来了一位身着白衣的人，向他敬礼。八融巴向他问好。来人说：“我很好，想求法，但是不敢。”八融巴详细讲授了皈依法和因果业法，并授居士戒。白衣人边听法，两眼不停地上下打量。又一天，白衣人又来了，他对达玛旺秋说：“我的亲戚和朋友也想来求法。”喇嘛八融巴说：“你不专心听法，他们求法又有何用？”白衣人说：“我是非人，谨慎学习，请向他们传法。”八融巴答应授法。男女夜叉众汇聚到八融巴跟前礼拜。八融巴象以前一样，向禅定者们讲授密法，使非人们欢喜。非人们提出献供，八融巴未作任何回答，从此之后达玛旺秋讲大手印修法，名声就象云雨一样传开。
                          数日后，八融巴达玛旺秋前往浦地方，途中听到一头牦牛的朗朗吽声，却不见牛。他一边想，一边向前走，突然发现一头刚刚被狼咬死的牛尸骨.他想这是否是本地牛,如果是,很可能是偷了别人家的牛留在这里的。八融巴边想边仔细察看，发现是藏北牛，心肺内脏已被挖去。他把牛腿等背回，剥皮处理，想这就是他给夜叉讲法回献的供品，是牦牛的幻化，夜叉们不高兴，拖入禅定，作为白居士的唤呼。白居士到来后，达玛旺秋说：“我授与你居士戒，讲因果业法，你做出如此恶罪，应该受到斥责。”白居士说：“牛不是我杀的，这里有厉鬼阎摩香神众，他们有随从夜狐，是夜狐杀的。”喇嘛八融巴说：“喇嘛仁波且达波拉杰指示我来八融地方修行，提防因果业。我奉上师教导住此地修行，你联合土地神造罪，不守三昧耶，现在我必须走。”白衣人和非人们一起保证说：“我们要断非人事，恪守三昧耶。我们是从莲花生来藏时期开始求学因果业法的三昧耶弟子，我们非人不管是谁尸体僵硬，不求法，上师你在旷无人烟的地方精进修行，显得非常孤独,因此，我们信仰你，并向你求法，发誓从今以后不做坏事，凡不是大阿闍黎你说的话一概不听。不管怎样，按照（上师）所说从现在开始至死前改变语气，改变态度，成佛前不违背上师教导，奉上师教导修行。”他们叩拜敬礼，认真请教。达玛旺秋说：“作为上师阿闍黎的弟子，能这样做很好。不要违背我的教诲，恪守戒律。你（白衣人）皈依护持佛教，尤其成为众生仆从种系的弟子，应给与保护拯救，做同伴朋友；不要违背三昧耶，一切都应随顺佛法，只有这样，我才能留下讲法。”非人们激动万分，牢记上师的教诲。不久，他们象彩虹一样消失在天空中。
                          期间，阿闍黎八融巴在洞中修行，突然门外响起唧唧聒聒的声音，他起身走出门站在一块磐石上观看，发现一群骑兵挟着一名伤员向他的方向跑来。当他正在思考之时，那伙人已经到了跟前，说：“好了，把伤员托给阿闍黎，我们自己逃跑。”言毕，将伤员放在阿闍黎面前，随即跑走了。八融巴远望，发现许多身着盔甲，手持武器的骑兵，举着剑紧追前面那伙人，嘴里不停地喊着“看往哪儿跑。”达玛旺秋劝说道：“不要跑，请听我言。”顿时，大家停止追跑，站着犯愁，稍后全部返回。
                          于是那些逃跑者来背受伤者，他们对上师毕恭毕敬，说：“今天全靠上师的搭救。”施礼后离去。骑兵们出现在（前方）说：“今天的争斗献给阿闍黎。”达玛旺秋说：“请将最好的物品献上。”他知道是他们鬼神，却假装不知道问：“你是哪个部落的人？”回答：我是非人，是扰乱这个地方的鬼神。“他们已经回去了。”
                          某日晚，听说以前那一少部分骑兵和伤病员全被消灭，剩下他们的妻子儿女被带到八融达玛旺秋跟前，积累了大批酥油和酥酪羔。他们的酋长扎西牵来一头奶牛，请轨范师恩护，并说：“那天，如果不把伤员托付，不逃跑，屠杀死亡的人会更多，现在要依上师教导习法，做上师的弟子。”喇嘛八融巴说：“当时你怎麽知道有我。”他回答说：“我们害怕逃跑时，看见磐石上烈火熊熊燃烧，火烟几乎触天，阿闍黎站在火中央，因此就将伤员托付你。追赶我们的那些人也看见了烈火中的您，所以不敢追上来。”阿闍黎讲法时，听法者说了声谢谢，就一切都消失了。
                          总之，八融巴达玛旺秋在杂仁钦耶巴地方修行四年，加上以岩洞为寺修行三年，共在两处住了七年。之后，应泽垄喀巴的邀请到康区，在蓝哈日纳作道歌、舞蹈，留下足迹。多年居住泽居郭佐岩洞，并在这里建寺，将众生引向成熟解脱。后来，回到八融寺，主持寺院十三年。一日，一把希有孔雀大伞在八融红岩堡上下的岩隅上方天空圆溜溜地转动。正当大家疑惑不解时，看见喇嘛八融巴站在大伞下面向东方天空眺望，并作出镇地手印。一次，为瓶和卷轴画佛像开光时，一名噶当派格西看见喇嘛八融巴的身体变成释迦牟尼佛。八融巴对那位格西说：“不要把你见到的说给其他人。”
                          有一天，几个人请求上师加持。在做资粮加持时，顿巴仁青喇嘛看见八融巴佩饰第六佛金刚持佛的装饰品，跳着九种舞姿，说：“我看见仁波且是这个样子。”八融巴对他说：“你看可以千万不要对他人讲。”
                          一次，喜饶坚参到八融巴的卧室，看见床上有佛薄伽梵胜乐俱生身。再仔细看原来是装饰装束。喜饶坚参准备慢慢离开时，听到问话声说：“谁？”“我。”又问“看见什麽了？”喜饶坚参回答：“床上有个人，不是阿闍黎，我不知道是什麽，准备离开。”八融巴说：“常言道调伏正法后，如果退回上师居住的门，应该用手轻敲，这样的话你没有听过吗？赤足悄声进来，偷看人修行，床上除了我还有谁，是你自己的眼睛有毛病，不要胡言乱语。”
                          一天黄昏，喜饶坚参看见佛母着饰华丽从床上起来，走到花堆盖花，定睛看确是佛母。上师八融巴说：“这时候了你不睡觉在干什麽？”喜饶坚参回答：“我看见阿闍黎起来。”“阿闍黎在何处？”“你自己不是吗？”八融巴质问道：“白昼吉祥呬噜迦，夜晚有饰瑜伽母，没听说过吗？”“听过。”“那就是了。”
                          有时，上师八融巴显出各种瑜伽士模样。据上师仁波且说：“这是非执乐和欢喜，而是入魔之因。如说：“以生上功能，精进侍上师，修习两种菩提心，认真作因果业，关键是诚心感戴根本上师。只有这样做了，能否生起功德，都是缘起所欺，因此不可能不生起。大手印是本心，除此别无他说，是用依靠上师的方法和积累自己的福泽通达证悟法性。若问由谁知道这些，如说：“他人非说是俱生，不住任何一切处，依赖上师之方便，依止自己之福泽。心静缘起大，自己了解自己。”又说：“即使自傲变心，也不要贪恋，必须保密。如果颠倒有无，即使自己有功能，而不保密，随便胡说，就会变成拭贝一样。尊者（佛）也梦见初地谛实，如果向他人宣说，微细暖相就会消失。密教秘密修，所以保密一切。”又说：“目睹佛薄伽梵六十二尊胜乐本尊、五部佛、第六佛金刚持之时，有天降的吉祥梵音颂。”
                          上师八融巴开讲法门时，进行加持；举行焚香仪轨之时，有些人目睹瑜伽母，姿态特殊。一次，索南坚参看见一束红光在（八融巴）床上回转，急忙退出门。当他进门再看时，上师八融巴朗朗吟歌。据说，上师八融巴住喇耶时，一位居士看见尊者他进入大悲观音六字母身说法。
                          尚增玛的一位侍从要求讲佛母修行法。如果这个人喜欢喝酒，即使喉咙被截断，仍然想要喝酒。阿闍黎讲授佛母修行法时，问他：“酒是瑜伽女，瑜伽女是酒影，若望殊胜位，不达彼等异，没有听说过吗？即使断了喉咙，对于不想饮酒的邪分别者来说，瑜伽母修行法有什麽用？舍金得雹，幼小野兽想食物，因食而怕，不要想苦了不求修行法。”
                          上师八融巴曾给施主旺艾之子一串本尊念珠，不久孩子死亡，据说尸体火化，从灰中发现本尊念珠完好无损，连顔色都没有变，八融巴将它挂在了旺艾脖子上。又说，八融巴授给施主贡布之子一条咒结绳，不久孩子患病去世，火化尸体时，咒结没被烧坏。第二天，孩子的父母从尸体中发现咒结，百思不得其解，问上师八融巴，上师说对于一切不要起疑心。
                          一次，弟子在卧室里看不见上师八融巴，他想刚才还在，为啥一下子不见了。当他出门离开时，听到身后上师问：“来了，为啥要走？”弟子回答：“我没有看见阿闍黎在房中，只见垫子。”八融巴说：“我一直在这里。”犹如浴衣遮面，虽然在房中，却什麽也没有。弟子问：“现在在吗？”八融巴说：“愚夫看来夏季的土地什麽都生，瑜伽士什麽都表演，你不知道吗？一切都是心境，不应实执；如果说印象，就会颠倒有无，现在无论如何你难以相信。如果你的样子那样，现在也会出现。对初学者说这个样子，对没有听过的人来说是错误，是走向罪恶的根本，现在必须保密。”
                          有时候，不需要地道标记，用感戴上师的特殊方式，恪守三昧耶，今生也能获得两种成就。经教说：“一刹那成佛。”这对愚昧迟钝，没有积累资粮的人来说不可思议。一次，马匪带走了来向寺院送粮的几个人，八融巴作了手势连同睇视法，使马惊跑，马匪掉进泥潭。八融巴说：“你们回去，不要救马腑脏。”
                          有个地方名叫觉都干札，由于日晒干旱，没有一点水。上师八融巴叫人拿来朵玛食子，灌入用手杖抽过的地方，祈求道：“世界力士嗡咒主人，我没有水，请快给水。”次日，派人去看时，杖抽过的地方有点潮湿。于是，又拿来朵玛食子灌入，说：“不过明早就会有水。”第二天去看时，果然有水，一股清泉淅淅沥沥流淌。八融巴对大家说：“取水饮用。”从此，当地人就饮用此泉水，病障全部消失。一次，弟子们看见喇嘛八融巴在达隆塘巴会见上师仁波且，承侍供养，一束彩虹覆盖在（喇嘛八融巴）的头顶。这样的希有景象颇多，恐文字冗长，不再赘述。
                          喇嘛仁波且吉祥八融巴，无执无虑，以一位瑜伽士的身份长期承侍达波拉杰，作为三时一切佛的身本性目睹正等觉报身佛第六佛金刚持，显现本尊神相，身功能圆满。他依上师教导修行，通达三时一切佛的经教，具语功能而祈祷，证悟成佛，是众生的希望。他是上师身语意双运洁身，通达一切生死轮涅法本性清净、刹那无断住；他不顾自己生命承侍上师仁波且（达波拉杰）修行，在杂钦拉果雪山的清净小庙孤身静修，犹如无所畏惧的狮子王，无等持与后得位，坚持修炼大手印法，使心坦然。他数次舍身除障，保护达波拉杰，奉献全部身心。最后，他又以多函经典、茶、金银、虎豹、甲胃、玉、瑚瑚、牛马等希有财物上供承侍，使受用圆满。他以心、身、受用承侍，使达波拉杰非常高兴。
                          众生怙主上师宝产生菩提心宝，遗体火化后出现了各种彩色舍利，圆满承侍，到达布施的彼岸，用手足、轮、莲花善饰，心成吉祥结图，清晰明朗；手莲向上细长，左手无名指根象吽字梳子，心大而有色，镇伏一切。通达内、外、秘一切法皆为缘起，无所缘之悲愍做众生事，用各种缘起（因缘）方式利益有情，即使离去也是为观世音菩萨的众生修成利乐后离去；坐也是跏趺坐，身体端直；以光明无来去方式卧睡，等引四威仪路；以六种神通秘密行，针对所化徒众的根器和随眠示现身、语、意事业。野兽保护他身、语、意慈业睡眠，众鸟保护其梦而坐手掌，落在鼻尖除眼脓。梦醒时，勇士与空行母奏响鼓，用手号（标记）提醒不要忘记誓约和离去的时间。
                          另外，上师仁波且亲眼目睹无数本尊神，表演空行、入水不沉、身庄严等；等至修定，穿行墙、岩，具有很大神通，获得大手印殊胜成就，证悟一切共同功德（知识），没有匹敌，这就是离辩论的大成就。这位众生怙主上师宝，没有生、老、病、死，但是他七十二岁时观见一些弟子（徒众），想按照正等觉佛的十二宏化，随做无上事业，一日梦见自己明年死。于是，他对弟子们说：“（明年）无论如何要走，不要把新来求法的人安置在我跟前，切记。”弟子说：“求法者不喜欢你，失望而回，去找其他上师，感戴小亏损大，因此有些人找不到法”。八融巴说：“不对，谒见离净的具相上师，诚心感戴，认真做因果业专修菩提心宝，毫无怀疑自己有大手印，不断了解，就能通达大手印也是自然任远而成，只要没有疑心，此生定会获得两种成就，众生不可思议的大事是缘起之大，谁也不能阻止。明年春季我要离开。”弟子问能否延长寿数？八融巴气愤地说：“愚夫们没听懂前面说的话吗？不要把上师的话当作真理标准。希望上师留下加持，那也是很痛苦的。你们不能自主，心里空虚时，才能想充实。不管怎样也不能阻止我明年离开。”一天晚上，八融巴又梦见来了一位上供者，说如果我现在去世，容易火化遗体。”
                          后来，来了许多索部落的茶商，其中一位是来送八融巴供品的。八融巴说：“如果一次和大家见面，他满足，怀疑无我。”梦见他们几人死去，说好。有人问：“不好吗？”上师八融巴说：“与彼不同，我上师高兴。精通教授要点，专心认真修炼，相信体验和证悟，不应怀疑。精通死相，因此没有好处。现在需要祈祷、集会，上弦日客人会来。”
                          六、七日后，上师八融巴患病，初一、初二日，献茶者先后到达，是上师来自远方的客人。八融巴叫他们到跟前来。考虑到上师宝的身体健康，弟子们决定这次不见，说在回路上见面。上师说：“回路上，我在哪里，你在哪里，自远方而来的人非常辛苦，不要阻止，必须见面。我不是看在礼品的分上，和他们会面是看外画，是聚集居家者和外出者。因此，必须现在见面。”上师八融巴为客人们讲授归依和发菩提心法。之后，会见寺院僧人，谆谆教导。
                          七、氏宿月（四月）初二日晚半夜时分，示现涅盘相。当时看见一股红光环绕天空，各种花雨降落，乐器声响亮，特别是响起宏亮的鼓和长腰鼓的声音，地动，喧杂声四起，出现了多种光、虹彩和相兆。初十日火化遗体，烟飘向正前方天空密布，一会儿又变成各种颜色的彩虹伞，在天空显现彩虹、莲花、树木、胜幢和旗幡等无数相状，给众生以喜悦。感戴之所依方面，各色舍利，象珠宝闪光，又象神工雕作，更象画师彩画，极为希奇，还有八瑞相、佛母像等形象舍利。
                          这样的法王众生怙主宝尊有许多优秀弟子，其中四大弟子是孜绒旺僧格、占迦觉增南喀、喇嘛钦波洛巴、顿巴仁波且喇嘛。
                          四位近侍弟子是：占迦拉顿、顿巴循努扎钦涅提婆（圣天）、拉杰洛哲却；
                          四大传承弟子：喇嘛仁波且止贡巴、喇嘛尼贡巴、喇嘛贝嘉、喇嘛僧格坚参；
                          两位心传弟子是：侄子嘉瓦扎巴、侄子喜饶旺秋。
                          殊胜弟子是：杰卓瓦贡波帝师慧狮子。 喜饶旺秋。
                          殊胜弟子是：杰卓瓦贡波帝师慧狮子。
                          </p>
                      </>
                    ) : lang === 'TIB' ? (
                      <h1>བོད་ཡིག་</h1>
                    ) : (
                          <h1>English</h1>
                        )}
                  </Tab.Pane>
                  <Tab.Pane eventKey='2' className='tabPane'></Tab.Pane>
                  <Tab.Pane eventKey='7' className='tabPane'>
                    {/* image 2 */}
                    <Image
                      src='https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fbarompa2.png?alt=media&token=34603f96-9d59-420a-abfc-41c26830c24e'
                      rounded
                      fluid
                      width='25%' />
                    <h4 className='chinese text-secondary mt-3'>
                      八融巴如我相
                       </h4>
                    <p className='chineseParagraph p-2'>
                      巴融噶舉傳承的法主蔣揚洛卓仁欽仁波切將文革期間被破壞的祖寺重建 包含所有的建築 佛像, 壁畫藝術 金剛舞的面具等,重建工程相當龐大當, 其中最重要的是閉關中心內的一尊傳承祖師 八融巴如我相,當年也是由仁波切指派我父親為首的幾位藝術家來重塑.
                      讓我印象最深刻的是父親當時告訴我,仁波切特別祈請八融巴祖師一定要讓這次的塑像如他本尊一模一樣的被塑造出來.根據父親口述,這尊如我相是用特別的甘露藏藥製成,並依照度量經上所指示的比例來塑造.
                      當時我在閉關中心的期間也經歷了許多關於這尊八融巴如我相的奇特經歷.記得有一年佛陀天降日的第二天我在閉關中心的壇城換八供水的時候法帽突然掉下來
                      剛好有一位在閉關中心常駐15年的老上師說，每一年的這個日子戴在八融巴如我相的法帽都會自動掉在八融巴如我相的手上.頓時我覺得不可思議,因此我在閉關中心的每一年都特別關注這件事情並觀察到確實是如此. 倉薩貢噶造 於2020.10.10
                        </p>
                    <div className='m-2'>
                      <PhotoGallery images={makers} />
                      <Row>
                        <Col className='text-lg-left'>
                          我父親倉薩江巴青美
                             </Col>
                        <Col className='text-lg-right'>
                          法主蔣揚洛卓仁欽仁波切
                             </Col>
                      </Row>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey='8' className='tabPane'>
                    <PhotoGallery images={hatImages} />
                  </Tab.Pane>
                  <Tab.Pane eventKey='9' className='tabPane'>
                    <PhotoGallery images={monastry1} />
                  </Tab.Pane>
                  <Tab.Pane eventKey='10' className='tabPane'>
                    <PhotoGallery images={mountain1} />
                    <p>འབའ་རོམ་པའི་སྒྲུབ་གནས། མདོ་ཡི་བྲག་དམར་རྫོང་ཆེན་ལ་ལོ་བདུན། རྫ་དེའུ་རིན་ཆེན་སྤུངས་པར་ལོ་བཞི། སྐྱོ་དུ་བྲག་དཀར་ལ་ལོ་གསུམ་སྒྲུབ་པ་མཛད།</p>
                    <h4 className='chinese text-secondary mt-3'>
                      八融巴的勝閉關地（贊青拉果神山）
                       </h4>
                    <hr />
                    <p className='chineseParagraph p-2'>
                      岡波巴當年預言指示八融巴必須去閉關的聖山即是贊青拉果神山(現在稱為桑丹康桑雪山或乃欽康桑雪山，海拔7162米),根據敦煌石窟記載及帝師日巴道歌、止貢巴的道歌、錫度班智達的傳記都提到八融的贊青拉果這座神山。又根據馬爾巴自傳裡提到念青唐古拉山脈與贊青拉果間的冰川在當時稱為贊雄冰川(現在稱為卡若拉冰川),都有對這座神山的讚頌。八融巴祖師閉關長達十四年的贊青拉果山(現在稱為桑丹康桑雪山或乃欽康桑雪山)是西藏四大神山之一,八融巴祖師也在這裡創建了八融傳承的寺廟。在藏族傳說中,贊青拉果山傳說說為吐蕃著名贊普赤德松贊的體神、山神是藏地盡人皆知具大法力的神靈。贊青拉果山神是一幅穿白衣，戴白巾，騎白馬的英武模樣。為免除對教法的威脅，他時常匆匆行進于世界八方，率領著他們的三百六十名隨從。倉薩貢噶造 於2020.10.13
                        </p>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </Container >
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(Kyagu1);
